import UpdateDataBlock from "@/features/datablocks/edit";

const EvidenceEdit = () => {
  return <UpdateDataBlock />;
};

export default EvidenceEdit;
